import { InstructionComponentProps } from "../InstructionComponent"

import IOS_1 from "../../../resources/tutorial/Update_ios.png"

import ANDROID_1 from "../../../resources/tutorial/AndroidDownload_Step1.png"
import ANDROID_2 from "../../../resources/tutorial/AndroidDownload_Step2.png"
import ANDROID_3 from "../../../resources/tutorial/AndroidDownload_Step3.png"
import ANDROID_4 from "../../../resources/tutorial/AndroidDownload_Step4.png"
import ImageTextComponent from "../../ImageTextComponent"
import Button from "../../Button"

const UpdateAppInstructions: InstructionComponentProps = {
    name: "Wie update ich die DOOR Studie Connect App?",
    path: "/help/patient/update",
    description:
        "Die Aktualisierung unterscheidet sich je nach Betriebssystem des mobilen Endgeräts.",
    ios: {
        steps: [
            <ImageTextComponent
                text={
                    "Bei einer Aktualisierung werden Sie normalerweise automatisch durch eine Benachrichtigung informiert. Sollte dies aber nicht der Fall sein, können Sie die Aktualisierung manuell durchführen. Dafür klicken Sie auf den Knopf unten und gleangen zum App Store. Hier klicken Sie nun auf Aktualisieren."
                }button={
                    <Button
                      onClick={() =>
                        window.open(
                          "https://apps.apple.com/de/app/door-studie-connect/id6741898497",
                          "_blank"
                        )
                      }
                    >
                      Zur App im Store
                    </Button>
                }
                images={[IOS_1]}
            />
        ]
    },
    android: {
        steps: [
            <ImageTextComponent
                text={
                    "Bei einer Aktualisierung werden Sie normalerweise automatisch durch eine Benachrichtigung informiert. Sollte dies aber nicht der Fall sein, können Sie die Aktualisierung manuell durchführen. Dafür klicken Sie auf den Knopf unten und gleangen zum App Store. Hier klicken Sie nun auf Aktualisieren."
                }button={
                    <Button
                      onClick={() =>
                        window.open(
                            //tbd
                          "TBD",
                          "_blank"
                        )
                      }
                    >
                      Zur App im Store
                    </Button>
                }
                images={[IOS_1]}
            />
        ]
    }
}

export default UpdateAppInstructions
